import { subMonths, isBefore } from "date-fns";

export const canWebhookResend = (createdAt: string | Date, status?: string): boolean => {
  return !isBefore(new Date(createdAt), subMonths(new Date(), 1)) && status !== 'in_progress';
};
